var _defs, _rect, _rect2, _g, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaudeInChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cic-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1E293B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#334155"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cic-window"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 35,
    width: 110,
    height: 90,
    rx: 8
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "url(#cic-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 35,
    width: 110,
    height: 90,
    rx: 8,
    fill: "#ffffff",
    opacity: 0.96
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cic-window)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 35,
    width: 110,
    height: 15,
    fill: "#334155",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 42.5,
    r: 2.5,
    fill: "#334155",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 42.5,
    r: 2.5,
    fill: "#334155",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 42.5,
    r: 2.5,
    fill: "#334155",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 64,
    x2: 112,
    y2: 64,
    stroke: "#334155",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 75,
    x2: 95,
    y2: 75,
    stroke: "#334155",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 86,
    x2: 105,
    y2: 86,
    stroke: "#334155",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 104,
    width: 110,
    height: 21,
    fill: "#D97757"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 114.5,
    r: 3.5,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 114.5,
    x2: 108,
    y2: 114.5,
    stroke: "#ffffff",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.9
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 31,
    width: 118,
    height: 98,
    rx: 11,
    fill: "none",
    stroke: "#D97757",
    strokeWidth: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaudeInChrome);
export default __webpack_public_path__ + "static/media/ClaudeInChrome.16cd9ea87ac8cd2aafde4967db75eb17.svg";
export { ForwardRef as ReactComponent };